import { ExclamationCircleOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { LoadingComponent } from "./LoadingComponent";
import { StatusPage } from "./StatusPage";
import { OIDC_WORKER_URL, registerOidcWorker } from "./customOidcUtils";
import { waitForOidcWorker } from "./waitForOidcWorker";

// Don't render the OIDC provider until the new service worker controls the page
export const OidcWorkerGate = ({ children }) => {
  const [status, setStatus] = useState("waiting");

  useEffect(() => {
    waitForOidcWorker(registerOidcWorker, OIDC_WORKER_URL)
      .then(() => setStatus("ready"))
      .catch((error) => {
        console.error("[oidc-worker] Application startup paused:", error);
        setStatus("failed");
      });
  }, []);

  if (status === "ready") return children;
  if (status === "failed") {
    return (
      <StatusPage
        icon={<ExclamationCircleOutlined />}
        tone="error"
        title="The page didn't finish loading"
        message="Check your connection and reload. If it still fails, close all open tabs of this site and restart your browser."
        buttonLabel="Reload"
        onButtonClick={() => window.location.reload()}
      />
    );
  }
  return <LoadingComponent />;
};
